import { Component, OnDestroy, Injector, ElementRef, ViewChild, forwardRef, Optional, Inject, OnInit, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { ArrowDirection } from '@apps/app.constants';
import { InputBase } from '@ui/components/form/base/input-base';
import { PopupTooltipService } from '@ui/misc/popup-tooltip/popup-tooltip.service';
import { PopupTooltipConfig } from '@ui/misc/popup-tooltip/cog/popup-tooltip-config';
import { DateRange } from '@common/models';

import { PopupRangeComponent } from './popup-range/popup-range.component';
import { PopupRangeParameters } from './popup-range/utils';

@Component({
    selector: 'aa-input-range',
    templateUrl: './input-range.component.html',
    styleUrls: [
        '../input.component.scss',
        './input-range.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputRangeComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class InputRangeComponent extends InputBase<DateRange> implements OnInit, OnDestroy
{
    @Input() parameters: PopupRangeParameters;
    @ViewChild('inputZone', { static: true }) inputZone: ElementRef;
    public arrowDirection: typeof ArrowDirection = ArrowDirection;
    public direction: ArrowDirection = ArrowDirection.CLOSED;
    private popupRangeComponent: PopupRangeComponent;
    private destroyator = new Subject();
    private static identifier: number = 0;

    constructor (
        injector: Injector,
        @Optional() @Inject(NG_VALIDATORS) _validators: Array<any>,
        private popupTooltipService: PopupTooltipService<PopupRangeComponent, PopupRangeParameters>,
        private elementRef: ElementRef
    )
    {
        super(injector);

        this.fieldId = `input-range-${InputRangeComponent.identifier++}-id`;
        this.notEnabled = true;
    }
    ngOnInit (): void
    {
        // this.popupRangeService.initConfig(this.config);
    }

    ngOnDestroy (): void
    {
        this.destroy();
    }

    public destroy ()
    {
        this.popupTooltipService.close();
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onClick (): void
    {
        if (this.direction === ArrowDirection.CLOSED)
        {
            const popupTooltipConfig = new PopupTooltipConfig();

            popupTooltipConfig.width = this.elementRef.nativeElement.getBoundingClientRect().width;
            popupTooltipConfig.height = 300;
            popupTooltipConfig.positions = [
                {
                    originX: 'start',
                    overlayX: 'start',
                    originY: 'bottom',
                    overlayY: 'top',
                    offsetY: -30
                },
                {
                    originX: 'start',
                    overlayX: 'start',
                    originY: 'top',
                    overlayY: 'bottom',
                    offsetY: -2
                }
            ];
            this.direction = ArrowDirection.OPEN;
            this.popupRangeComponent = this.popupTooltipService.create(this.inputZone, PopupRangeComponent, popupTooltipConfig, this.parameters);
            this.popupRangeComponent.hasActionButtons = false;
            this.popupRangeComponent.popupRangeClosed
                .pipe(
                    tap((dateRange: DateRange) =>
                    {
                        this.value = dateRange;
                        this.direction = ArrowDirection.CLOSED;
                        this.popupTooltipService.close();
                    }),
                    takeUntil(this.destroyator)
                )
                .subscribe();
            this.popupRangeComponent.popupRangeChanged
                .pipe(
                    tap((dateRange: DateRange) =>
                        this.value = dateRange
                    ),
                    takeUntil(this.destroyator)
                )
                .subscribe();
        }
        else
        {
            this.direction = ArrowDirection.CLOSED;
            this.popupTooltipService.close();
        }
    }
}
